/** ActiveCampaign: the person's mirrored fields, collapsed. Read only. The section is left out when the mirror cannot be read. A person added in Keystone is never sent there (#731): it says so, over any contact the mirror links by their email. */
import { useState } from "react";
import { getMemberSyncActivity } from "../../api/syncActivity";
import { useQuery } from "../data/useQuery";
import { fmtWhen } from "../data/format";
import { Button, SheetRows, SheetSection, SkeletonText } from "../kit";
import { fmtDate } from "./format";

/** The mirror keeps AC's own words and ISO dates; the sheet says Licence and dates as the lists do. */
const labelOf = (label: string): string => label.replace(/^License/, "Licence");
const valueOf = (value: string): string => (/^\d{4}-\d{2}-\d{2}/.test(value) ? fmtDate(value) : value) || "—";

export const acKey = (id: number): string => `v2:person:${id}:ac`;
export const loadAc = (id: number) => getMemberSyncActivity(id);

export function AcFields({ id }: { id: number }) {
  const [open, setOpen] = useState(false);
  const { data, loading } = useQuery(acKey(id), () => loadAc(id));

  if (!loading && !data) return null;
  const contact = data?.contact;
  const rows: Array<readonly [string, string]> = contact ? [["Mirror read", fmtWhen(contact.mirroredAt) ?? "—"], ...contact.fields.map((f) => [labelOf(f.label), valueOf(f.value)] as const)] : [];
  return (
    <SheetSection title="ActiveCampaign">
      {loading ? (
        <SkeletonText width="16ch" className="text-body" />
      ) : !contact ? (
        <p className="text-body leading-none text-muted-foreground">{data?.neverSent ? "Never sent to ActiveCampaign" : "Not in ActiveCampaign"}</p>
      ) : (
        <>
          {data?.neverSent && <p className="text-body leading-none text-muted-foreground">Never sent to ActiveCampaign</p>}
          <Button variant="ghost" size="sm" className="-ml-2 self-start" aria-expanded={open} onClick={() => setOpen(!open)}>
            Fields
          </Button>
          {open && <SheetRows rows={rows} />}
        </>
      )}
    </SheetSection>
  );
}
